import { render, staticRenderFns } from "./MachineSidebar.vue?vue&type=template&id=453501d0&scoped=true&"
import script from "./MachineSidebar.vue?vue&type=script&lang=js&"
export * from "./MachineSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MachineSidebar.vue?vue&type=style&index=0&id=453501d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453501d0",
  null
  
)

export default component.exports